export const usersOnlyInventory = ["marina", "romana", "chavon", "multiplaza", "minitas"]